import React, { useRef, useState, useEffect } from "react";
import styles from "../css/CardHSPUProgressProfile.module.css";
import { BsFillPlayBtnFill, BsPlusCircleFill } from "react-icons/bs";
import data_program from "../data/data_program";
import { FaLock, FaUnlockAlt } from "react-icons/fa";
import { FiRefreshCw } from "react-icons/fi";
import {
  setProgressProcessingFlag,
  fetchClosestCommunityVideos,
  saveUserCommentToProgress,
  recordFirstUploadDate,
} from "./dynamoUtils";
import ModalCongratsLevel from "./ModalCongratsLevel";
import ModalVideo from "./ModalVideo";
import { fetchPrioritizedVideos } from "./dynamoUtils";
import VideoUploader from "./VideoUploader";
import AvatarEditor from "./AvatarEditor";
import { fetchUserProgressFromDB } from "./dynamoUtils";
import { toYouTubeEmbed, looksLikeVideoFilePath } from "./dynamoUtils";

function CardHSPUProgressProfile({
  data_user,
  isOwnProfile,
  onUpdateProgress,
  journeyCompletion,
  externalUser,
  externalLevelToOpen,
  externalBestUrl,
}) {
  const cardRef = useRef(null);
  const [showVideo, setShowVideo] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [selectedLevel, setSelectedLevel] = useState(null);

  const [enteredProgress, setEnteredProgress] = useState("");
  const [progressDate, setProgressDate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [comment, setComment] = useState("");

  const [customModal, setCustomModal] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [flashProcessing, setFlashProcessing] = useState(false);
  const [completedLevels, setCompletedLevels] = useState([]);
  const [showCongratsModal, setShowCongratsModal] = useState(false);
  const [congratsLevel, setCongratsLevel] = useState(null);
  const [videoKind, setVideoKind] = useState("youtube"); // 'youtube' | 'file'


  const user = data_user?.[0];
  const DEFAULT_AVATAR_URL =
    "https://t4astorage580ed-dev.s3.us-east-2.amazonaws.com/public/avatars/avatar_alien_white.jpeg";

  const hasCustomAvatar =
    !!user &&
    (
      (user.avatarOriginal && user.avatarOriginal !== "none") ||
      (user.avatar && user.avatar.toLowerCase() !== "none" && user.avatar !== DEFAULT_AVATAR_URL)
    );
  const [locallyProcessingCode, setLocallyProcessingCode] = useState(null);
  const [showCarousel, setShowCarousel] = useState(false);
  const [carouselVideos, setCarouselVideos] = useState([]);
  const [currentCarouselIndex, setCurrentCarouselIndex] = useState(0);
  const [currentTitle, setCurrentTitle] = useState("");
  const [currentStatus, setCurrentStatus] = useState(null); // "unlocked" | "progress" | null


  const getTitleFromCode = (code) => {
    const p = data_program.find((d) => d.progress_code === code);
    return p ? `Level - ${p.progression}` : "Progress Video";
  };

  const currentBest =
    selectedLevel && user?.progressData
      ? user.progressData.find((p) => p.progress_code === selectedLevel)?.best ?? 0
      : 0;

  // Validation flags
  const [repsTouched, setRepsTouched] = useState(false);
  const numericReps = enteredProgress === "" ? NaN : Number(enteredProgress);
  const repsValid =
    !Number.isNaN(numericReps) && numericReps >= currentBest && numericReps > 0;

  const getInlayImageUrl = (progressCode) =>
    `https://t4astorage580ed-dev.s3.us-east-2.amazonaws.com/public/inlays/t4a_${progressCode}_inlay_bg_black.png`;

  const openCarouselVideo = async (defaultUrl, progress_code) => {
    let fetched = await fetchPrioritizedVideos(progress_code);
    fetched = Array.isArray(fetched) ? fetched : [];

    console.group(`🔍 openCarouselVideo – progress_code=${progress_code}`);
    console.log("📥 Fetched from Dynamo:", fetched);

    // --- helpers -------------------------------------------------
    const isUnlock = (v) => {
      const src = (v?.source || "").toLowerCase();
      const cat = (v?.category || "").toLowerCase();
      const status = (v?.status || "").toLowerCase();
      const type = (v?.type || "").toLowerCase();

      const result =
        src === "unlock" ||
        src === "unlocked" ||
        cat === "unlock" ||
        cat === "unlocked" ||
        status === "unlock" ||
        status === "unlocked" ||
        type === "unlock" ||
        type === "unlocked" ||
        v?.unlock === true ||
        v?.isUnlock === true;

      console.log(
        `%c🔎 isUnlock?`,
        `color:${result ? "limegreen" : "red"}`,
        v,
        "→",
        result
      );

      return result;
    };

    const isDefaultByUrl = (v) => {
      if (!defaultUrl || !v?.url) return false;
      const embeddedDefault = toYouTubeEmbed(defaultUrl) || defaultUrl;
      const result = v.url === defaultUrl || v.url === embeddedDefault;

      console.log(
        `%c🎯 isDefaultByUrl?`,
        `color:${result ? "orange" : "gray"}`,
        { defaultUrl, embeddedDefault, videoUrl: v.url },
        "→",
        result
      );

      return result;
    };

    // --- classify fetched videos --------------------------------
    console.log("🧪 Classifying fetched videos…");
    fetched.forEach((v, i) => {
      console.log(`%cVideo #${i}`, "color:cyan", v);
      isUnlock(v);
      isDefaultByUrl(v);
    });

    const unlocks = fetched.filter(isUnlock);
    const others = fetched.filter((v) => !isUnlock(v));

    console.log("🔓 unlocks:", unlocks);
    console.log("📦 others:", others);

    let finalVideos = [];

    if (unlocks.length > 0) {
      // ✅ Any unlock → no default at all
      console.log("%c🚨 UNLOCK FOUND → default will be REMOVED", "color:yellow");
      const cleanedOthers = others.filter(
        (v) => !isDefaultByUrl(v) && v.source !== "default"
      );
      finalVideos = [...unlocks, ...cleanedOthers];
      console.log("👉 finalVideos (unlock mode):", finalVideos);
    } else {
      // ✅ No unlocks → default allowed
      console.log(
        "%cℹ️ No unlocks detected → default may be included",
        "color:lightblue"
      );

      let defaultVideo = null;
      if (defaultUrl) {
        const yt = toYouTubeEmbed(defaultUrl);
        defaultVideo = yt
          ? {
            url: yt,
            kind: "youtube",
            username: "Program Default",
            date: "",
            source: "default",
          }
          : looksLikeVideoFilePath(defaultUrl)
            ? {
              url: defaultUrl,
              kind: "file",
              username: "Program Default",
              date: "",
              source: "default",
            }
            : null;
      }

      const nonDefaultOthers = others.filter(
        (v) => !isDefaultByUrl(v) && v.source !== "default"
      );

      if (nonDefaultOthers.length === 0) {
        console.log("🟦 No others → just default");
        if (defaultVideo) finalVideos = [defaultVideo];
      } else {
        console.log("🟩 No unlocks but others exist → default first, then others");
        finalVideos = defaultVideo
          ? [defaultVideo, ...nonDefaultOthers]
          : [...nonDefaultOthers];
      }

      console.log("👉 finalVideos (no-unlock mode):", finalVideos);
    }

    console.groupEnd();

    if (!finalVideos.length) return;

    const programItem = data_program.find(
      (item) => item.progress_code === progress_code
    );
    const levelTitle = `Level - ${programItem?.progression ?? ""}`;

    setCarouselVideos(finalVideos);
    setCurrentCarouselIndex(0);
    setCurrentTitle(levelTitle);
    setShowCarousel(true);
  };


  const getCompletedLevels = (progressData) => {
    const completed = [];
    for (let level = 1; level <= 7; level++) {
      const levelTasks = data_program.filter((d) => d.progress_code.startsWith(`l${level}`));
      const isComplete = levelTasks.every((task) => {
        const entry = progressData.find((p) => p.progress_code === task.progress_code);
        const goal = Number(task.goal);
        return entry && !isNaN(goal) && entry.best >= goal;
      });
      if (isComplete && levelTasks.length > 0) completed.push(level);
    }
    return completed;
  };

  useEffect(() => {
    if (!externalLevelToOpen || !user) return;

    const levelCode = externalLevelToOpen; // e.g. "l1b"

    const programItem = data_program.find(
      (d) => d.progress_code === levelCode
    );

    const progressEntry = user.progressData?.find(
      (p) => p.progress_code === levelCode
    );

    // Prefer external URL from /progress/zarrar/l1b
    const urlToOpen = externalBestUrl || progressEntry?.best_url;
    if (!urlToOpen) return;

    // determine unlocked vs progress
    const goal = programItem?.goal ?? 0;
    const isUnlocked =
      progressEntry && goal > 0 ? progressEntry.best >= goal : false;

    // 🔥 Set the same fields you set when clicking from the table
    setCurrentTitle(getTitleFromCode(levelCode));
    setCurrentStatus(isUnlocked ? "unlocked" : "progress");

    // 🔥 Use the same video resolver
    openVideo(urlToOpen);
  }, [externalLevelToOpen, externalBestUrl, user]);

  useEffect(() => {
    if (user?.progressData) {
      const initial = getCompletedLevels(user.progressData);
      setCompletedLevels(initial);
    }
  }, [user]);

  const openProgressModal = (level) => {
    if (!hasCustomAvatar) {
      setCustomModal({
        type: "requireAvatar",
        message: "",
      });
      return;
    }
    setSelectedLevel(level);
    setEnteredProgress("");
    setRepsTouched(false);
    setProgressDate(new Date().toLocaleDateString("en-CA"));
    setComment("");
    setShowProgressModal(true);
  };

  const closeProgressModal = () => {
    setShowProgressModal(false);
    setSelectedLevel(null);
    setEnteredProgress("");
    setRepsTouched(false);
    setComment("");
  };

  // Auto-save flow to run AFTER upload completes
  const handleSaveProgress = async () => {
    if (!selectedLevel) return;
    const user0 = data_user[0];
    const newProgress = parseInt(enteredProgress, 10);
    if (Number.isNaN(newProgress)) return;

    // optimistic UI: compute potential newly-completed levels
    const simulatedProgressData = user0.progressData.map((p) =>
      p.progress_code === selectedLevel
        ? { ...p, best: Math.max(p.best || 0, newProgress) }
        : p
    );
    const simulatedCompletedLevels = getCompletedLevels(simulatedProgressData);
    const newlyCompleted = simulatedCompletedLevels.find((lvl) => !completedLevels.includes(lvl));
    if (newlyCompleted) {
      setCompletedLevels(simulatedCompletedLevels);
      setCongratsLevel(newlyCompleted);
      setShowCongratsModal(true);
    }

    try {
      await setProgressProcessingFlag(user0.username, selectedLevel, true);
      setLocallyProcessingCode(selectedLevel);
      await saveUserCommentToProgress(user0.username, selectedLevel, comment);
      await recordFirstUploadDate(user0.username);

      if (onUpdateProgress) await onUpdateProgress();

      const { lower, higher } = await fetchClosestCommunityVideos(
        selectedLevel,
        user0.username,
        newProgress
      );
      const hasAnyRelated = lower || higher;

      setCustomModal({
        title: "Video Uploaded! ✅",
        message: hasAnyRelated
          ? `We'll email once your video is ready!\n\nMeanwhile, check these out:`
          : `We'll email once your video is ready`,
        related: hasAnyRelated ? { lower, higher } : null,
      });

      closeProgressModal();
    } catch (error) {
      console.error("❌ Post-upload error:", error);
      setCustomModal({
        title: "Something went wrong",
        message: "We updated your progress, but couldn’t finalize everything. Please try again.",
      });
    }
  };

  useEffect(() => {
    const shouldLock = showProgressModal || customModal;
    if (shouldLock) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [showProgressModal, customModal]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (showVideo && cardRef.current && !cardRef.current.contains(event.target)) {
        closeVideo();
      }
    };
    window.addEventListener("click", handleOutsideClick);
    return () => window.removeEventListener("click", handleOutsideClick);
  }, [showVideo]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        if (showProgressModal) closeProgressModal();
        if (showVideo) closeVideo();
        if (customModal) setCustomModal(null);
      }
      // Prevent any accidental form submissions on Enter
      if (e.key === "Enter" && showProgressModal) {
        e.preventDefault();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showProgressModal, showVideo, customModal]);

  const processingItem =
    user?.progressData?.find((entry) => entry.processing === true) ||
    (locallyProcessingCode &&
      user?.progressData?.find((entry) => entry.progress_code === locallyProcessingCode));

  const processingInfo = processingItem
    ? { code: processingItem.progress_code, username: user.username }
    : null;

  if ((!data_user || !data_user[0] || !data_user[0].progressData) && !processingInfo) {
    return <h3>Loading user data...</h3>;
  }

  const openVideo = async (url) => {
    if (!url) {
      setShowVideo(false);
      return;
    }

    let resolved = null;

    // YouTube?
    const yt = toYouTubeEmbed(url);
    if (yt) resolved = { url: yt, kind: "youtube" };

    // Direct file by extension?
    if (!resolved && looksLikeVideoFilePath(url)) {
      resolved = { url, kind: "file" };
    }

    // Last-resort HEAD probe for content-type
    if (!resolved) {
      try {
        const res = await fetch(url, { method: "HEAD" });
        const ct = (res.headers.get("content-type") || "").toLowerCase();
        if (
          ct.startsWith("video/") ||
          ct.includes("application/vnd.apple.mpegurl") || // m3u8
          ct.includes("application/dash+xml")            // mpd
        ) {
          resolved = { url, kind: "file" };
        }
      } catch { /* ignore */ }
    }

    if (!resolved) {
      setShowVideo(false);
      return;
    }

    setVideoUrl(resolved.url);
    setVideoKind(resolved.kind);
    setShowVideo(true);
  };

  const closeVideo = () => {
    setShowVideo(false);
    setVideoUrl("");
    window.history.pushState({}, "", "/progress");
  };

  const determineUnlockedLevel = () => {
    let highestSequentiallyCompletedLevel = -1;
    for (let level = 0; level < 7; level++) {
      const levelTasks = data_program.filter((d) => d.level === `Level ${level + 1}`);
      const levelComplete = levelTasks.every((d) => {
        const up = data_user[0].progressData.find((i) => i.progress_code === d.progress_code);
        const progressPercentage = up ? Math.min((up.best / d.goal) * 100, 100) : 0;
        return progressPercentage >= 100;
      });
      if (levelComplete) highestSequentiallyCompletedLevel = level;
      else break;
    }
    return highestSequentiallyCompletedLevel + 2;
  };

  const unlockedLevelIndex = determineUnlockedLevel();
  const isAnyProcessing =
    user?.progressData?.some((entry) => entry.processing === true) ||
    locallyProcessingCode != null;

  // --- legacy filename helpers ---
  const month3Lower = (d) =>
    d.toLocaleString("en-US", { month: "short" }).toLowerCase();

  const fmtDateToken = (isoYmd /* e.g. "2025-08-10" */) => {
    const [y, m, d] = isoYmd.split("-").map((v) => parseInt(v, 10));
    const dt = new Date(y, m - 1, d);
    const dd = String(dt.getDate()).padStart(2, "0");
    return `${dd}${month3Lower(dt)}${dt.getFullYear()}`; // 08aug2025
  };

  const extOf = (file) => {
    const n = file?.name || "";
    const dot = n.lastIndexOf(".");
    const ext = dot >= 0 ? n.slice(dot + 1).toLowerCase() : "";
    return ext || "mp4";
  };

  // Build the exact legacy filename the ECS pipeline expects
  const makeLegacyKey = (file) => {
    const user0 = data_user?.[0];
    if (!user0) throw new Error("No user loaded");

    // require a selected level and valid reps (the UI already enforces this)
    if (!selectedLevel) throw new Error("No progress level selected");
    if (!enteredProgress) throw new Error("No progress value set");

    const goalForSelected =
      data_program.find((p) => p.progress_code === selectedLevel)?.goal ?? 0;

    const reps = parseInt(enteredProgress, 10);
    const ptype = reps >= goalForSelected ? "unlocked" : "progress";

    // progressDate is already in "YYYY-MM-DD"
    const dateToken = fmtDateToken(progressDate);
    const username = user0.username;
    const code = selectedLevel;
    const goal = goalForSelected;
    const ext = extOf(file);

    const filename = `${username}_hspu_${code}_${goal}_${reps}_${dateToken}_${ptype}.${ext}`;
    return `public/uploads/videos/${filename}`; // <- IMPORTANT: keep this prefix
  };

  return (
    <div className={styles.card} ref={cardRef}>
      <table className={styles.cardTable}>
        <thead>
          <tr>
            <th className={styles.firstCol}>Progression</th>
            <th className={styles.secondCol}>Best</th>
          </tr>
        </thead>
        <tbody>
          {data_program.map((data, dataIndex) => {
            const level = parseInt(data.progress_code.charAt(1), 10);
            return (
              <tr key={dataIndex} className={`${styles.level}-${level}`}>
                <td
                  className={`${styles.firstCol} ${styles.progressionCell}`}
                  style={{
                    background: data.color,
                    color: data.color === "white" ? "black" : "white",
                    textAlign: "left",
                  }}
                  onClick={() => openCarouselVideo(data.videoUrl, data.progress_code)}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <button
                      className={`${styles.watchVideoButton} ${isAnyProcessing
                        ? styles.processingWatch
                        : isOwnProfile
                          ? styles.ownProfileWatch
                          : styles.otherProfileWatch
                        }`}
                      style={{ color: data.color === "white" ? "black" : "white" }}
                    >
                      <BsFillPlayBtnFill className={styles.watchVideoIcon} />
                    </button>
                    <span>{data.progression}</span>
                  </div>
                </td>

                {data_user.slice(0, 1).map((user, userIndex) => {
                  const userProgress = user.progressData.find(
                    (item) => item.progress_code === data.progress_code
                  );
                  const rawProgressPercentage = userProgress
                    ? (userProgress.best / data.goal) * 100
                    : 0;
                  const barWidthPercentage = Math.min(rawProgressPercentage, 100);

                  return (
                    <React.Fragment key={userIndex}>
                      <td
                        className={`${styles.secondCol}`}
                        style={{
                          background: data.color,
                          color: data.color === "white" ? "black" : "white",
                          width: "150px",
                        }}
                      >
                        <div
                          className={`${styles.progressBarContainer} ${isOwnProfile ? styles.withPlusIcon : styles.noPlusIcon
                            }`}
                        >
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {processingInfo?.code === data.progress_code &&
                              processingInfo?.username === user.username ? (
                              <div
                                className={styles.processingText}
                                onClick={async () => {
                                  setIsRefreshing(true);
                                  setFlashProcessing(true);
                                  setTimeout(() => {
                                    window.location.reload();
                                  }, 1500);
                                }}
                                style={{
                                  cursor: "pointer",
                                  color: data.color === "white" ? "black" : "white",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  width: "100%",
                                  gap: "6px",
                                }}
                              >
                                {flashProcessing ? (
                                  <span>Still Processing...</span>
                                ) : (
                                  <span style={{ display: "inline-flex", alignItems: "center" }}>
                                    Processing
                                    <span className={styles.processingDotsWrapper}>
                                      <span className={styles.dot}></span>
                                      <span className={styles.dot}></span>
                                      <span className={styles.dot}></span>
                                    </span>
                                  </span>
                                )}
                                <FiRefreshCw
                                  className={isRefreshing ? styles.spin : ""}
                                  style={{
                                    fontSize: "1rem",
                                    color: data.color === "white" ? "black" : "white",
                                  }}
                                  title="Click to Refresh"
                                />
                              </div>
                            ) : (
                              <>
                                {userProgress && userProgress.best > 0 && (
                                  <button
                                    className={`${styles.watchVideoButton} ${isAnyProcessing
                                      ? styles.processingWatch
                                      : isOwnProfile
                                        ? styles.ownProfileWatch
                                        : styles.otherProfileWatch
                                      }`}
                                    style={{ color: data.color === "white" ? "black" : "white" }}
                                    onClick={() => {
                                      const isUnlocked = userProgress.best >= data.goal;
                                      setCurrentTitle(getTitleFromCode(data.progress_code));
                                      setCurrentStatus(isUnlocked ? "unlocked" : "progress");
                                      userProgress.best_url
                                        ? openVideo(userProgress.best_url)
                                        : openVideo(null);
                                    }}
                                  >
                                    <BsFillPlayBtnFill className={styles.watchVideoIcon} />
                                  </button>
                                )}
                                {userProgress && userProgress.best > 0 ? (
                                  <div
                                    className={`${styles.progressBar} ${isOwnProfile
                                      ? styles.ownProfileBar
                                      : styles.otherProfileBar
                                      }`}
                                  >
                                    <span className={styles.progressPercentageLeft}>
                                      {userProgress.best}
                                    </span>
                                    <div
                                      className={styles.progressFill}
                                      style={{
                                        width: `${barWidthPercentage}%`,
                                        backgroundColor:
                                          rawProgressPercentage < 25
                                            ? "#E74C3C"
                                            : rawProgressPercentage < 50
                                              ? "#E67E22"
                                              : rawProgressPercentage < 75
                                                ? "#F1C40F"
                                                : rawProgressPercentage < 100
                                                  ? "#3498DB"
                                                  : "#2ECC71",
                                      }}
                                    />
                                    <span className={styles.progressPercentageRight}>
                                      {`${rawProgressPercentage.toFixed(0)}%`}
                                    </span>
                                  </div>
                                ) : (
                                  <div className={styles.lockedIcon}>
                                    {parseInt(data.progress_code.charAt(1), 10) ===
                                      unlockedLevelIndex ? (
                                      <div className={styles.iconGroup}>
                                        <FaUnlockAlt className={styles.unlockedIcon} />
                                        {isOwnProfile && !isAnyProcessing && (
                                          <button
                                            className={styles.plusIconButton}
                                            style={{
                                              color: data.color === "white" ? "black" : "white",
                                            }}
                                            onClick={() => openProgressModal(data.progress_code)}
                                          >
                                            <BsPlusCircleFill className={styles.plusIconButton} />
                                          </button>
                                        )}
                                      </div>
                                    ) : (
                                      <FaLock style={{ color: "silver" }} />
                                    )}
                                  </div>
                                )}
                                {userProgress && userProgress.best > 0 && (
                                  <>
                                    {isOwnProfile && !isAnyProcessing && (
                                      <button
                                        className={styles.plusIconButton}
                                        style={{
                                          color: data.color === "white" ? "black" : "white",
                                        }}
                                        onClick={() => openProgressModal(data.progress_code)}
                                      >
                                        <BsPlusCircleFill className={styles.plusIconButton} />
                                      </button>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </td>
                    </React.Fragment>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>

      {showProgressModal && (
        <div
          className={styles.progressModalWrapper}
          onClick={(e) => {
            if (e.target === e.currentTarget) closeProgressModal();
          }}
        >
          <div className={styles.progressModal}>
            <div className={styles.modalContent}>
              <div className={styles.modalHeader} style={{ textAlign: "center" }}>
                {selectedLevel ? (
                  <img
                    src={getInlayImageUrl(selectedLevel)}
                    alt={selectedLevel}
                    style={{
                      width: "100%",
                      maxWidth: "400px",
                      height: "auto",
                      borderRadius: "12px",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                    }}
                  />
                ) : (
                  <h3>Upload Progress</h3>
                )}
              </div>

              <div className={styles.modalBody}>
                {/* Reps input (Enter does NOT submit form) */}
                <div className={styles.fieldWrap}>
                  <input
                    id="reps-input"
                    type="number"
                    step="1"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={enteredProgress}
                    onChange={(e) => {
                      const v = e.target.value.replace(/[^0-9]/g, "");
                      setEnteredProgress(v);
                    }}
                    onBlur={() => setRepsTouched(true)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        setRepsTouched(true);
                      }
                    }}
                    placeholder={`Enter your reps (≥ ${currentBest})`}
                    className={styles.inputField}
                    aria-describedby="reps-alert"
                  />

                  {repsTouched &&
                    enteredProgress !== "" &&
                    !Number.isNaN(numericReps) &&
                    numericReps < currentBest && (
                      <div id="reps-alert" className={styles.inlineAlert} role="alert" aria-live="polite">
                        Reps must be ≥ your previous best ({currentBest}).
                      </div>
                    )}
                </div>

                {/* Date and Comment ABOVE the uploader */}
                <input
                  type="date"
                  value={progressDate}
                  onChange={(e) => setProgressDate(e.target.value)}
                  className={styles.inputField}
                />

                <textarea
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Any thoughts, tips, or reflections from this session? (Optional)"
                  className={styles.inputField}
                  rows={2}
                />

                <div className={styles.uploaderField}>
                  <VideoUploader
                    makeKey={makeLegacyKey}
                    canUpload={repsValid && hasCustomAvatar}
                    isRepValid={repsValid}
                    explainWhyCannotUpload={
                      !hasCustomAvatar
                        ? "Please update your Avatar before you can upload a video."
                        : (!repsValid ? "Enter valid reps (≥ your current best) to enable upload." : "")
                    }
                    onRequireMeta={() => document.getElementById("reps-input")?.focus()}
                    onComplete={handleSaveProgress}
                    onCancel={() => { setEnteredProgress(""); setRepsTouched(false); setComment(""); }}
                    onClose={closeProgressModal}
                  />
                </div>
              </div>
              {/* Removed the old Save / Cancel footer buttons */}
            </div>
          </div>
        </div>
      )}

      {showVideo && (
        <ModalVideo
          show={showVideo}
          videos={[
            {
              url: videoUrl,
              kind: videoKind,              // <-- use the kind we resolved
              username: user?.displayName || user?.username || "",
              date: "",
              progress: "",
              source: "personal",
              status: currentStatus,
            },
          ]}
          currentIndex={0}
          setCurrentIndex={() => { }}
          onClose={closeVideo}
          currentTitle={currentTitle}
        />
      )}

      {customModal && (
        <div
          className={styles.progressModalWrapper}
          onClick={(e) => {
            // click on dark backdrop closes
            if (e.target === e.currentTarget) setCustomModal(null);
          }}
        >
          <div className={styles.progressModal}>
            <div className={styles.modalContent}>
              <div className={styles.modalHeader}>
                <h3>{customModal.title}</h3>
              </div>
              <div className={styles.modalCloseX} onClick={() => setCustomModal(null)}>
                &times;
              </div>
              <div className={styles.modalBody}>
                {customModal.type === "requireAvatar" ? (
                  <>
                    <p style={{ fontSize: 16, marginBottom: 12 }}>
                      Please update your Avatar before you can upload a video.
                    </p>
                    <div style={{ position: "relative" }}>
                      <div style={{ display: "grid", placeItems: "center" }}>
                        <AvatarEditor
                          username={user?.username}
                          initialAvatarUrl={
                            user?.avatar &&
                              user.avatar.toLowerCase() !== "none" &&
                              user.avatar !== DEFAULT_AVATAR_URL
                              ? user.avatar
                              : DEFAULT_AVATAR_URL
                          }
                          onAvatarChange={async () => {
                            // force parent to reload user so hasCustomAvatar flips to true:
                            try {
                              if (onUpdateProgress) await onUpdateProgress();
                            } catch { }
                            setCustomModal(null);
                          }}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <p style={{ whiteSpace: "pre-line", fontSize: 16 }}>
                      {customModal.message}
                    </p>
                    {customModal.related &&
                      (() => {
                        const { lower, higher, list } = customModal.related || {};
                        const items = Array.isArray(list)
                          ? list
                          : [lower, higher].filter(Boolean);
                        if (!items.length) return null;

                        // Sort by the order that data_program appears (L1a, L1b, ..., L7c)
                        const orderMap = Object.fromEntries(
                          data_program.map((p, idx) => [p.progress_code, idx])
                        );
                        items.sort((a, b) => {
                          const ca = a?.progress_code || a?.code || "";
                          const cb = b?.progress_code || b?.code || "";
                          const ia = orderMap[ca] ?? Number.POSITIVE_INFINITY;
                          const ib = orderMap[cb] ?? Number.POSITIVE_INFINITY;
                          return ia - ib;
                        });

                        const descByCode = Object.fromEntries(
                          data_program.map((p) => [p.progress_code, p.progression])
                        );
                        const goalByCode = Object.fromEntries(
                          data_program.map((p) => [p.progress_code, Number(p.goal) || 0])
                        );

                        const cleanDesc = (s = "") =>
                          s.replace(/^\s*\d+[a-c]\s*-\s*/i, "");
                        const renderCodePretty = (code = "") => {
                          const m = code.match(/^l(\d)([abc])$/i);
                          if (!m) return code.toUpperCase();
                          const level = m[1];
                          const sub = m[2].toLowerCase();
                          return (
                            <>
                              L{level}
                              <span
                                style={{
                                  fontSize: "1em",
                                  position: "static",
                                  verticalAlign: "baseline",
                                  marginLeft: 0,
                                }}
                              >
                                {sub}
                              </span>
                            </>
                          );
                        };

                        const AvatarCard = ({ video }) => {
                          const code = video.progress_code || video.code || "";

                          // What we show in the UI (pretty display name)
                          const prettyName = video.displayName || video.username || "community";

                          // Canonical username for DB + avatar filenames (never prettified)
                          const canonicalUsername = (video.username || "community").toLowerCase();

                          const href = video.url?.startsWith("http")
                            ? video.url
                            : `https://www.thenics4all.com${video.url || ""}`;

                          const [best, setBest] = React.useState(
                            Number.isFinite(Number(video.progress))
                              ? Number(video.progress)
                              : null
                          );

                          React.useEffect(() => {
                            let alive = true;
                            (async () => {
                              if (best == null && canonicalUsername && code) {
                                try {
                                  const list = await fetchUserProgressFromDB(canonicalUsername);
                                  const entry = list.find((p) => p.progress_code === code);
                                  if (alive) {
                                    setBest(
                                      entry && Number.isFinite(Number(entry.best))
                                        ? Number(entry.best)
                                        : null
                                    );
                                  }
                                } catch {
                                  // ignore errors
                                }
                              }
                            })();
                            return () => {
                              alive = false;
                            };
                          }, [best, canonicalUsername, code]);

                          const goal = goalByCode[code] || 0;
                          const haveProgress = best != null && goal > 0;
                          const pct = haveProgress ? Math.round((best / goal) * 100) : null;

                          const rawDesc = descByCode[code] || code.toUpperCase();
                          const desc = cleanDesc(rawDesc);
                          const avatarUrl = `https://t4astorage580ed-dev.s3.us-east-2.amazonaws.com/public/avatars/avatar_${canonicalUsername}.jpg`;
                          const gold = "#d4af37";

                          return (
                            <a
                              href={href}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                                width: 180,
                                textAlign: "center",
                              }}
                            >
                              {/* Line 1: L-code */}
                              <div
                                style={{
                                  fontSize: 16,
                                  fontWeight: 800,
                                  color: "#fff",
                                  lineHeight: 1.3,
                                }}
                              >
                                {renderCodePretty(code)}
                              </div>

                              {/* Line 2: Description */}
                              <div
                                style={{
                                  fontSize: 14,
                                  color: "#eaeaea",
                                  marginBottom: 8,
                                  lineHeight: 1.3,
                                }}
                              >
                                {desc}
                              </div>

                              {/* Line 3: Avatar */}
                              <div
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                }}
                              >
                                <img
                                  src={avatarUrl}
                                  alt={prettyName}
                                  width={120}
                                  height={120}
                                  style={{
                                    borderRadius: "50%",
                                    border: "3px solid #fff",   // ✅ fixed string here
                                    boxShadow: "0 0 12px rgba(0,0,0,0.5)",
                                    objectFit: "cover",
                                  }}
                                  onError={(e) => {
                                    e.currentTarget.src =
                                      "https://t4astorage580ed-dev.s3.us-east-2.amazonaws.com/public/avatars/avatar_alien_white.jpeg";
                                  }}
                                />
                              </div>

                              {/* Line 4: Username */}
                              <div
                                style={{
                                  marginTop: 10,
                                  fontWeight: 800,
                                  fontSize: 15,
                                  color: "#fff",
                                  letterSpacing: 0.3,
                                  textTransform: "lowercase", // keep or remove depending on style you want
                                }}
                              >
                                {prettyName}
                              </div>

                              {/* Line 5: Progress */}
                              {haveProgress && (
                                <div
                                  style={{
                                    marginTop: 4,
                                    fontSize: 13,
                                    color: gold,
                                    fontWeight: 700,
                                    textShadow: "0 0 6px rgba(212,175,55,0.6)",
                                  }}
                                >
                                  {best} of {goal} ({pct}%)
                                </div>
                              )}
                            </a>
                          );
                        };



                        return (
                          <div className={styles.relatedGrid}>
                            {items.map((v, i) => (
                              <AvatarCard key={i} video={v} />
                            ))}
                          </div>
                        );
                      })()}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showCongratsModal && (
        <ModalCongratsLevel
          show={showCongratsModal}
          onHide={() => setShowCongratsModal(false)}
          levelNumber={congratsLevel}
        />
      )}

      {showCarousel && (
        <ModalVideo
          show={showCarousel}
          videos={carouselVideos}
          currentIndex={currentCarouselIndex}
          setCurrentIndex={setCurrentCarouselIndex}
          onClose={() => setShowCarousel(false)}
          currentTitle={currentTitle}
        />
      )}
    </div>
  );
}

export default CardHSPUProgressProfile;
